function Footer() {
    return (
        <footer className="footer">
            <div className="container">
                <h2>Made by &copy;Dehui , 2022 , inspired by @Brad Traversy</h2>
            </div>
        </footer>
    )
}



export default Footer